export const SET_MEMBER = 'SET_MEMBER';
export const CLEAR_MEMBER = 'CLEAR_MEMBER';
export const SET_OVER_YEAR_OTP = 'SET_OVER_YEAR_OTP';

export const mutations = {
    [SET_MEMBER](state, payload) {
        state.user = payload;
        state.isLogin = true;
    },
    [SET_OVER_YEAR_OTP](state, payload) {
        state.overYearOtp = Object.assign({}, payload);
    },
    [CLEAR_MEMBER](state) {
        state.user = null;
        state.isLogin = false;
    },
};
